import React, { useEffect, useRef, useState, useMemo } from 'react';
import ReactDOM from 'react-dom';
import { useClickAway } from 'react-use';
import { Resizable } from 'react-resizable';
import { Icon } from '../icon';
import { IconButton } from '../icon-button';
import { CardHeader } from '../card';
import { SidebarWrapper, SidebarContent, FooterWrapper, Shading } from './styled';
const voidFunc = () => {
    return;
};
const DEFAULT_WIDTH = 360;
export const Sidebar = ({ children, isOpen = false, handleResizeSide, shadeBackground = false, style = {}, position, onClose, onClickOutside, id = 'aside-portal', title, key, Wrapper = SidebarWrapper, Header = CardHeader, Content = SidebarContent, Footer, ...props }) => {
    const sidebarPortalWrapperRef = useRef(null);
    const [node, setNode] = useState(null);
    const initialWidth = useMemo(() => { var _a, _b; return Number.parseInt((_b = (_a = style === null || style === void 0 ? void 0 : style.width) === null || _a === void 0 ? void 0 : _a.toString()) !== null && _b !== void 0 ? _b : ''); }, []);
    const [width, setWidth] = useState(Number.isNaN(initialWidth) ? DEFAULT_WIDTH : initialWidth);
    const handleSetWidth = (e, { size: { width } }) => setWidth(width);
    useClickAway(sidebarPortalWrapperRef, onClickOutside !== null && onClickOutside !== void 0 ? onClickOutside : voidFunc);
    const resizeHandles = useMemo(() => {
        if (handleResizeSide === 'left')
            return ['w'];
        if (handleResizeSide === 'right')
            return ['e'];
        return [];
    }, [handleResizeSide]);
    useEffect(() => {
        const eliminateNode = (node) => {
            setNode(null);
            ReactDOM.unmountComponentAtNode(node);
            node.remove();
        };
        const createNode = (id) => {
            const portalNode = document.createElement('aside');
            portalNode.id = id;
            portalNode.hidden = !isOpen;
            document.body.appendChild(portalNode);
            return portalNode;
        };
        const prevNode = document.getElementById(id);
        if (prevNode)
            eliminateNode(prevNode);
        const newNode = createNode(id);
        setNode(newNode);
        return () => {
            newNode && eliminateNode(newNode);
        };
    }, [id, isOpen]);
    return !isOpen || !node
        ? null
        : ReactDOM.createPortal(React.createElement(React.Fragment, null,
            shadeBackground ? React.createElement(Shading, { "data-testid": "sidebar-shading" }) : null,
            React.createElement(Resizable, { axis: "x", width: width, onResize: handleSetWidth, resizeHandles: resizeHandles },
                React.createElement(Wrapper, { style: { ...style, width }, 
                    // @ts-ignore
                    ref: sidebarPortalWrapperRef, "$position": position, action: onClose ? (React.createElement(IconButton, { "data-testid": "btn-close-sidebar", onClick: onClose },
                        React.createElement(Icon, { name: "close" }))) : undefined, ...props },
                    title && React.createElement(Header, { component: "h4" }, title),
                    React.createElement(Content, null, children),
                    Footer && React.createElement(FooterWrapper, null, Footer)))), node, key);
};
